import CockpitSetupLink from "./CockpitSetupLink";

const NewSite = (props: { cockpitOn?: boolean; fairId?: string }) => {
  return (
    <div>
      {props.cockpitOn ? (
        <CockpitSetupLink
          fairId={props.fairId}
          lead="Apply the event template, set dates and logo, then work the season checklist from Cockpit. This is the first-time setup path while a full new-site wizard is still coming."
        />
      ) : (
        <div>TODO: Mike it goes here.</div>
      )}
    </div>
  );
};

export default NewSite;